import { __, invertObj, prop } from 'ramda';

import { CATEGORY } from '../../../types/filters';

export const PRISMIC_TO_TYPE_CATEGORY = {
  Innovation: CATEGORY.SERVICES,
  'Idée reçue': CATEGORY.MISCONCEPTION,
  Veille: CATEGORY.RIGHT_NOW,
  Évènement: CATEGORY.EVENT,
  Podcast: CATEGORY.INTERVIEW,
  'Grand angle': CATEGORY.CASE,
  Récit: CATEGORY.LIFESPIRATION,
  Éclairage: CATEGORY.POINT_OF_VIEW,
  'Start-up': CATEGORY.FOCUS,
  Repères: CATEGORY.KEYS_FIGURES,
  Rencontre: CATEGORY.PORTRAIT,
  'Page interne': CATEGORY.INNER_PAGE,
  Publication: CATEGORY.PUBLICATION,
};

export const toCategoryType = prop(__, PRISMIC_TO_TYPE_CATEGORY);
export const toCategoryPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_CATEGORY));
